import { HEADER_CONFIG } from "@/src_new/shared/config/header.config";
import { WHITE_LABEL_CONFIG } from "@/src_new/whiteLabel";
import { useState } from "react";
import { Link } from "react-router-dom";

type Props = {
  className?: string;
  imageClassName?: string;
  textClassName?: string;
};

export default function BrandLogo({
  className = "inline-flex flex-col leading-tight",
  imageClassName = "h-10 w-auto max-w-[180px] object-contain md:h-11",
  textClassName = "text-2xl font-extrabold tracking-tight text-theme-text",
}: Props) {
  const [hasImageError, setHasImageError] = useState(false);
  const { brand } = HEADER_CONFIG;
  const { logo, fallbackText } = WHITE_LABEL_CONFIG.brand;
  const showImageLogo = Boolean(logo?.src) && !hasImageError;
  const safeFallbackText = fallbackText?.trim() || logo?.alt?.trim() || "Brand";

  return (
    <Link to={brand.link || "/"} className={className}>
      {showImageLogo ? (
        <img
          src={logo.src}
          alt={logo.alt}
          width={logo.width}
          height={logo.height}
          className={imageClassName}
          onError={() => setHasImageError(true)}
        />
      ) : (
        <span className={textClassName}>{safeFallbackText}</span>
      )}
    </Link>
  );
}
